import React, { useState, useContext, useEffect } from "react";
import { getImages } from "../Const";
import { LeadsContext } from "../Context/LeadsContext";
import { UserContext } from "../Context/UserContext";

const SendPlainTextEmail = ({ close, leadData, handleTabClick }) => {

    const { emailScripts, leadFields, agentData, sendPlainTextEmail, numberFormatter } = useContext(LeadsContext);

    const {user} = useContext(UserContext);

    const [selectedOption, setSelectedOption] = useState(0);

    const [emailSubject, setEmailSubject] = useState("");
    const [emailBody, setEmailBody] = useState("");

    const [selectedAgentIndex, setSelectedAgentIndex] = useState(0);

    const [leadEmail, setLeadEmail] = useState("");

    const selectAgent = (i) => {

        setSelectedAgentIndex(i);
    }

    const handleSelectChange = (value) => {
        console.log(value,leadData);
        
        setSelectedOption(value);
    
        if (!emailScripts || !emailScripts[value]) return; // Ensure script exists
    
        generateContent(value);
    };

    const generateContent = (value) => {
        let this_subject = emailScripts[value].subject || "";
        let this_script = emailScripts[value].script || "";
    
        // Ensure leadData and leadFields are defined
        if (leadData && leadFields) {
            leadFields.forEach((field) => {
                var text_value = field.includes('agent_') && selectedAgentIndex in agentData && field.replace('agent_','') in agentData[selectedAgentIndex] ? agentData[selectedAgentIndex][field.replace('agent_','')] : (leadData[field] || "");;
                if(field == "appraisal") {
                    text_value = !leadData[field] ? "$XX,XXX" : numberFormatter(leadData[field],true);
                }
                this_subject = this_subject.replaceAll(`[${field}]`, text_value);
                this_script = this_script.replaceAll(`[${field}]`, text_value);
            });
        }
    
        setEmailSubject(this_subject);
        setEmailBody(this_script);
    }

    const handleEmailBody = (body) => {
        setEmailBody(body);
    }

    const sendEmail = async (e) => {
        e.preventDefault();

        const formData = Object.fromEntries(new FormData(e.target));

        const response = await sendPlainTextEmail(formData, leadData, selectedAgentIndex in agentData ? agentData[selectedAgentIndex] : {});

        if (response && response.success) {
            //close();
            alert('Your email has been sent');
            handleTabClick("AppraisalMain");
        } else alert('Error sending email');
    }

    const [emailHistory, setEmailHistory] = useState([]);

    useEffect(() => {
        if (!leadData) return; // Ensure leadData is not undefined
    
        handleSelectChange(selectedOption);
    
        if (agentData && Array.isArray(agentData)) {

            //selectAgent(agentData.findIndex((agent) => agent.email == leadData.agent_email));

            selectAgent(agentData.findIndex((agent) => agent.id == user.user_id));
        }
    
        setLeadEmail(leadData.email || "");
    
        if (leadData.notes) {
            const email_history = leadData.notes
                .filter((v) => v.title === "Sent Email" || v.title === "Received Email")
                .map((v) => {
                    const createdAtDate = new Date(v.created_at + " UTC");
    
                    return {
                        ...v,
                        time: createdAtDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
                        date: createdAtDate.toLocaleString('en-US', { year: "2-digit", month: "2-digit", day: "numeric" }),
                    };
                });
    
            setEmailHistory(email_history);
        }
    }, [leadData?.id]);

    useEffect(() => {
        console.log(selectedAgentIndex,selectedOption);
        if (emailScripts.length > 0) {
            handleSelectChange(selectedOption);
        }
    }, [emailScripts, selectedAgentIndex]);

    return (
        <>
        {/*console.log("agentData", agentData)}
        {console.log("emailScripts", emailScripts)*/}
            <div className="mb-2 mt-4 d-flex justify-content-between">
                <div className="md-title text-uppercase">Plain Text Email {leadData.vehicle_name ? " - " + leadData.vehicle_name : ""} {leadData.status ? " - " + leadData.status : ""}</div>
                {/*<button
                    // onClick={() => {
                    //     close();
                    //     onAddScriptBtnClick();
                    // }}
                    className="text-nowrap blue-transparent-btn dark-transparent-btn text-uppercase"
                    type="button"
                >
                    <span className="blue-add-icon"></span> Add script
                </button>*/}
            </div>
            <form className="custom-form form-style2" onSubmit={(e) => sendEmail(e)}>
                <input type="hidden" name="email" value={leadEmail || ""} />
                <input type="hidden" name="lead_id" value={leadData.id || ""} />
                <div className="form-group mb-3">
                    <label>Select Sender</label>
                    <select
                        name="agent_email"
                        className="form-control"
                        onChange={(e) => selectAgent(e.target.value)}
                        value={selectedAgentIndex}
                    >
                        {agentData.map((agent, i) =>
                            <option key={i} value={i}>{agent.full_name}</option>
                        )}
                    </select>
                </div>
                <div className="form-group mb-3">
                    <label>Select Script</label>
                    <select
                        name="script"
                        className="form-control"
                        onChange={(e) => handleSelectChange(e.target.value)}
                        value={selectedOption}
                    >
                        {emailScripts.map((script, i) =>
                            <option key={i} value={i} style={{display:script.store ? "" : "none"}}>{script.script_name}</option>
                        )}
                    </select>
                </div>
                <div className="form-group mb-3">
                    <label>Subject</label>
                    <input
                        type="text"
                        name="subject"
                        className="form-control"
                        value={emailSubject}
                        onChange={(e) => setEmailSubject(e.target.value)}
                    />
                </div>
                <div className="form-group mb-4">
                    <label>Message</label>
                    <textarea className="msgitem msgItem1 form-control h260" name="message" value={emailBody} onChange={(e) => handleEmailBody(e.target.value)}>
                    </textarea>
                </div>
                <div className="text-end">
                    <button
                        className="blue-btn mnw-170 text-center text-uppercase"
                        type="submit"
                    >
                        <span className="send-icon"></span> SEND Message
                    </button>
                </div>
            </form>
        </>
    );
};

export default SendPlainTextEmail;
